export class PDFError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'PDF_Error'
  }
}

export class APIError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'API_Error'
  }
}

export class ReviewError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'Review_Error'
  }
}

export class LoadError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'Load_Error'
  }
}

export class AnalysisError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'Analysis_Error'
  }
}

export class AttributeError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'Attribute_Error'
  }
}

export class ValidationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'Validation_Error'
  }
}

export class SSOError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'SSO_Error'
  }
}

export class StreamError extends Error {
  code?: string
  constructor(message: string, code?: string) {
    super(message)
    this.name = 'Stream_Error'
    this.code = code
  }
}

export class AgentError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'Agent_Error'
  }
}
